import Relay from 'react-relay';

export default {
  viewer: () => Relay.QL`query { user(id: $userId) }`
};



/** WEBPACK FOOTER **
 ** ./src/queries/UserQueries.js
 **/